import { IFormViewForm } from 'components/FormView';

const CreditNoteDetailsForm: IFormViewForm = {
    id: 'CreditNoteDetailsForm',
    layout: {
        rows: 2,
        columns: 3
    },
    fields: [
        {
            id: 1,
            position: {
                row: 1,
                col: 1
            },
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                label: 'Postal address',
                fullWidth: true
            },
            children: [
                {
                    id: 1,
                    type: 'ADDRESS_BLOCK',
                    props: {
                        label: '',
                        name: 'PostalAddress',
                        required: false,
                        type: 'extended',
                    }
                },
            ]
        },
        {
            id: 1,
            position: {
                row: 1,
                col: 2
            },
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                fullWidth: true,
                label: 'Delivery address',
            },
            children: [
                {
                    id: 2,
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Site',
                        size: 'small',
                        name: 'SiteCode',
                        lookupName: 'DeliverySite',
                        suppressDescription: true,
                        suppressValidation: true,
                        isCustomerScoped: true,
                        isLookupTypeFixed: true
                    }
                },
                {
                    id: 2,
                    type: 'ADDRESS_BLOCK',
                    props: {
                        label: '',
                        name: 'DeliveryAddress',
                        required: false,
                        type: 'extended',
                    }
                },
            ]
        },
        {
            id: 1,
            position: {
                row: 1,
                col: 3
            },
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                fullWidth: true
            },
            children: [
                {
                    id: 1,
                    type: 'TEXT_FIELD',
                    visible: true,
                    props: {
                        label: 'Sales terms',
                        name: 'Terms',
                        type: 'number',
                        size: 'small',
                        alignment: 'left',
                        required: true
                    }
                },
                {
                    id: 2,
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        name: 'TaxClass',
                        label: 'Tax class',
                        size: 'small',
                        lookupName: 'CustomerTaxClass',
                    }
                },
                {
                    id: 3,
                    type: 'TEXT_FIELD',
                    props: {
                        name: 'TaxExemptReference',
                        label: 'Tax exempt reference',
                        size: 'medium',
                    }
                },
                {
                    id: 4,
                    type: 'TEXT_FIELD',
                    props: {
                        name: 'Age',
                        label: 'Age',
                        type: 'number',
                        size: 'small',
                        alignment: 'right',
                        disabled: true,
                    }
                },
                {
                    id: 5,
                    type: 'EX_LOOKUP_FIELD',
                    visible: true,
                    props: {
                        label: 'Territory',
                        name: 'Territory',
                        placeholder: '',
                        size: 'small',
                        lookupName: 'SalesTerritory',
                        required: true
                    }
                },
                {
                    id: 6,
                    type: 'EX_LOOKUP_FIELD',
                    visible: true,
                    props: {
                        label: 'Sales rep',
                        name: 'SalesRepresentative',
                        placeholder: '',
                        size: 'small',
                        lookupName: 'SalesRep',
                        required: true
                    }
                },
            ]
        },
        {
            id: 1,
            position: {
                row: 2,
                col: 1
            },
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                fullWidth: true
            },
            children: [
                {
                    id: 1,
                    type: 'TEXT_FIELD',
                    visible: true,
                    props: {
                        label: 'Reference',
                        name: 'Reference',
                        size: 'medium',
                    }
                },
                {
                    id: 2,
                    type: 'TEXT_FIELD',
                    props: {
                        name: 'Instruction1',
                        label: 'Instructions',
                        size: 'large',
                    }
                },
                {
                    id: 3,
                    type: 'TEXT_FIELD',
                    props: {
                        name: 'Instruction2',
                        label: '',
                        size: 'large',
                    }
                },
            ]
        },
    ]
};

export default CreditNoteDetailsForm;
